import React from "react"
import { Button, Modal, Form, Col, InputGroup } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import ActionButton from "../ActionButton"
import { UserActivationObservable } from "../../api/Administration/ActivationProcess"
import UserInformation from "../../api/Administration/Model/UserInformation"
import { ActiveUserInformationGetObservable } from "../../api/Administration/UserInformationGet"
import { EmailRegexp } from "../../config/Constants"
import { AppPageWrapper } from "../NavMenu/AppPageWrapper"
import { RouteComponentProps } from "react-router"
import { Home } from "../../config/Routes"

interface UserActivationProps { }

interface UserActivationState {
  saving: boolean
  loading: boolean
  selectedUser?: UserInformation
  isEmailValid: boolean
  email: string
}

export default class UserActivation extends React.PureComponent<UserActivationProps, UserActivationState> {
  emptyState: UserActivationState = {
    loading: false,
    saving: false,
    selectedUser: undefined,
    isEmailValid: false,
    email: ""
  }
  state: UserActivationState = { ...this.emptyState }

  loadUserSubscription?: Subscription
  saveUserSubscription?: Subscription

  componentWillUnmount() {
    this.saveUserSubscription && this.saveUserSubscription.unsubscribe()
    this.loadUserSubscription && this.loadUserSubscription.unsubscribe()
  }

  handleCancel = () => (this.props as RouteComponentProps).history?.push(Home)

  handleActivate = () => {
    this.setState({ saving: true })
    const { selectedUser } = this.state

    this.saveUserSubscription = UserActivationObservable(selectedUser?.ApplicationUserID || 0, selectedUser?.Link || "").subscribe(
      (data) => toast.success(data),
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ saving: false })
      },
      () => this.setState({ ...this.emptyState })
    )
  }

  handleRetrieve = () => {
    this.setState({ loading: true, selectedUser: undefined })
    const { email } = this.state

    this.loadUserSubscription = ActiveUserInformationGetObservable(email, true).subscribe(
      (data: UserInformation[]) => this.setState({ selectedUser: data[0], loading: false }),
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ loading: false })
      }
    )
  }

  isEmailValid = (value: string) => {
    if (value.length === 0) {
      return false
    }
    return EmailRegexp.test(value)
  }

  render() {
    const { selectedUser, saving, loading } = this.state

    return (
      <AppPageWrapper showNav>
        <Modal.Dialog size="xl">
          <Modal.Header>
            <Modal.Title className="text-uppercase">Activate User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Row className="form-group required">
                <Form.Label column lg={3} htmlFor="userName">User's Email</Form.Label>
                <Col lg={9}>
                  <InputGroup>
                    <Form.Control type="text" value={this.state.email} className="bg-white" onChange={(e) => { this.setState({ email: e.target.value, isEmailValid: this.isEmailValid(e.target.value) }) }} />
                    <InputGroup.Append>
                      <ActionButton variant="secondary" onClick={this.handleRetrieve} disabled={!this.state.isEmailValid} spin={loading} disableOnSpin>Retrieve</ActionButton>
                    </InputGroup.Append>
                  </InputGroup>
                </Col>
              </Form.Row>
              <Form.Row className="form-group">
                <Form.Label column lg={3} htmlFor="firstName">First Name</Form.Label>
                <Col lg={9}>
                  <Form.Control id="firstName" type="text" disabled defaultValue={selectedUser?.FirstName} />
                </Col>
              </Form.Row>
              <Form.Row className="form-group">
                <Form.Label column lg={3} htmlFor="lastName">Last Name</Form.Label>
                <Col lg={9}>
                  <Form.Control id="lastName" type="text" disabled defaultValue={selectedUser?.LastName} />
                </Col>
              </Form.Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <ActionButton variant="primary" onClick={() => this.handleActivate()} disabled={!selectedUser} spin={saving} disableOnSpin>Activate</ActionButton>
            <Button variant="secondary" className="mr-2" onClick={() => this.handleCancel()}>Cancel</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </AppPageWrapper>
    )
  }
}
